/**
 * Companies whose `terms_accepted_at` is before this date see the agreement
 * modal. This is the re-acceptance trigger and is deliberately separate from
 * the current revision's date: publishing new agreement text does not force
 * existing companies to accept again. Bump it to the current revision's date
 * only when everyone must re-accept (STR-917 shipped new text without doing so).
 *
 * Kept as a UTC instant so the cutoff is the same in every viewer's timezone
 * (a date-only string would parse as local midnight).
 */
export const TERMS_ENFORCED_SINCE = '2022-06-16T00:00:00Z';
